<script>
  let { yScale, width, index = 0 } = $props()

  const hideAxes = $derived(index >= 10)
</script>

<g style:opacity={hideAxes ? 0 : 1} style:transition="opacity 0.6s ease">
  <!-- Top Label -->
  <g
    transform="translate({Math.max(20, width / 2 - 320)}, {index >= 9
      ? yScale(1) - 40
      : yScale(1) - 40})"
  >
    <line x1="0" y1="25" x2="0" y2="-15" stroke="rgba(255,255,255,0.8)" stroke-width="1.2" />
    <polyline
      points="-4,-11 0,-15 4,-11"
      fill="none"
      stroke="rgba(255,255,255,0.8)"
      stroke-width="1.2"
      stroke-linejoin="miter"
      stroke-linecap="butt"
    />
    <text
      x="15"
      y="-2"
      text-anchor="start"
      fill="rgba(255,255,255,0.8)"
      font-size="14"
      font-family="CuratorRegular"
    >
      <tspan x="15" dy="0">Sounds more like</tspan>
      <tspan x="15" dy="20">an HDB estate</tspan>
    </text>
  </g>

  <!-- Bottom Label -->
  <g
    style:transition="transform 0.6s ease"
    transform="translate({Math.max(20, width / 2 - 320)}, {yScale(0) +
      10 -
      (index >= 9 ? 40 : 40)})"
  >
    <line x1="0" y1="-10" x2="0" y2="30" stroke="rgba(255,255,255,0.8)" stroke-width="1.2" />
    <polyline
      points="-4,26 0,30 4,26"
      fill="none"
      stroke="rgba(255,255,255,0.8)"
      stroke-width="1.2"
      stroke-linejoin="miter"
      stroke-linecap="butt"
    />
    <text
      x="15"
      y="3"
      text-anchor="start"
      fill="rgba(255,255,255,0.8)"
      font-size="14"
      font-family="CuratorRegular"
    >
      <tspan x="15" dy="0">Sounds more</tspan>
      <tspan x="15" dy="20">like a condo</tspan>
    </text>
  </g>
</g>
